import { useTranslation } from 'react-i18next';
import { CardContainer } from '../../cardContainer';
import { IconWaveSawTool } from '@tabler/icons';
import { ListItem } from '../../listItem';
import { Box, Flex, Skeleton, Stack } from '@mantine/core';
import { FC, useEffect } from 'react';
import { HealthServiceType } from '@/entities/admin-app/user';
import useHomeWidgetSlice from '@/store/homeWidget/useHomeWidgetSlice';

interface IServicesSectionProps {
  filialId: number;
}

export const ServicesSection: FC<IServicesSectionProps> = ({ filialId }) => {
  const { t } = useTranslation();
  const [{ data, isLoading }] = useHomeWidgetSlice().useServicesWidget().useState();
  const { LoadServicesSection } = useHomeWidgetSlice().actions;

  useEffect(() => {
    LoadServicesSection(filialId);
  }, []);

  const servicesList =
    data?.map((item: any) => {
      const serviceName = t(`filials.services.${HealthServiceType[item.Type]}`);
      return {
        name: item.Name ? `${serviceName} ${item.Name}` : serviceName,
        valid: item.Health
      };
    }) || [];

  if (isLoading) {
    return (
      <CardContainer sectionName={t('filials.availableServices')} Icon={IconWaveSawTool}>
        <Box w="100%">
          {Array(8)
            .fill(0)
            .map((_, index) => (
              <Flex justify="space-between" align="center" mb="xs" key={index}>
                <Skeleton height={20} width="70%" radius="xl" />
                <Skeleton height={20} width={20} circle />
              </Flex>
            ))}
        </Box>
      </CardContainer>
    );
  }

  return (
    <CardContainer sectionName={t('filials.availableServices')} Icon={IconWaveSawTool}>
      <Stack gap="7px" sx={{ width: '100%' }} mt="16px">
        <ListItem items={servicesList} withCheck={true} />
      </Stack>
    </CardContainer>
  );
};
